import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';

export const MobileImageWrapper = styled.picture`
  width: 100%;
  height: 100%;

  img {
    display: block;
    position: unset !important;
  }

  ${DESKTOP} {
    display: none;
  }
`;

export const DesktopImageWrapper = styled.picture`
  display: none;

  ${DESKTOP} {
    display: block;
    width: 100%;
    height: 100%;
    max-width: 820px;

    img {
      display: block;
      position: unset !important;
    }
  }
`;
